/* ============================================================
   MyFlizo — shared front-end behaviour
   - scroll reveal (.mf-reveal) with gentle cascade
   - animated counters ([data-mf-count])
   - FAQ / product accordions (.mf-acc)
   - size & bundle selectors on the PDP (.mf-pdp)
   - sticky ATC visibility
   All progressive-enhancement: page is fully usable without JS.
   ============================================================ */
(function () {
  if (window.__mfInit) return;
  window.__mfInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function armReveals() {
    var vh = window.innerHeight || 800;
    document.querySelectorAll('.mf-reveal').forEach(function (el) {
      if (el.classList.contains('mf-in')) return;
      el.classList.add('mf-armed');
      if (el.getBoundingClientRect().top <= vh - 60) {
        requestAnimationFrame(function () { el.classList.add('mf-in'); });
      }
    });
  }
  function revealScan() {
    var vh = window.innerHeight || 800;
    var batch = [];
    document.querySelectorAll('.mf-reveal.mf-armed:not(.mf-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh - 60) batch.push(el);
    });
    batch.sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top; });
    var prevTop = null, step = -1;
    batch.forEach(function (el) {
      var t = Math.round(el.getBoundingClientRect().top);
      if (prevTop === null || Math.abs(t - prevTop) > 24) { step++; prevTop = t; }
      el.style.transitionDelay = Math.min(step * 80, 320) + 'ms';
      el.classList.add('mf-in');
      setTimeout(function () { el.style.transitionDelay = ''; }, 1200);
    });
    // :not([data-mf-cart]) is belt-and-braces: the counter must never grab the cart drawer
    document.querySelectorAll('[data-mf-count]:not([data-mf-done]):not([data-mf-cart])').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh - 40) animateCount(el);
    });
  }
  function animateCount(el) {
    el.setAttribute('data-mf-done', '1');
    var target = parseFloat(el.getAttribute('data-mf-count')) || 0;
    var suffix = el.getAttribute('data-mf-suffix') || '';
    if (reduce) { el.textContent = target + suffix; return; }
    var dur = 1400, start = performance.now();
    function tick(now) {
      var p = Math.min(1, (now - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * e) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var ticking = false;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () { revealScan(); stickyScan(); totopScan(); ticking = false; });
    }
  }

  /* ---------- accordions ---------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('.mf-acc__head').forEach(function (btn) {
      if (btn.__mf) return; btn.__mf = true;
      btn.addEventListener('click', function () {
        var item = btn.closest('.mf-acc__item');
        var panel = item.querySelector('.mf-acc__panel');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---------- PDP size / bundle selectors ---------- */
  function initPdp(root) {
    (root || document).querySelectorAll('.mf-pdp').forEach(function (pdp) {
      if (pdp.__mf) return; pdp.__mf = true;
      // gallery thumbnails -> swap the main image
      pdp.querySelectorAll('[data-mf-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full'); if (!full) return;
          var main = pdp.querySelector('.mf-pdp__main-img');
          if (main && main.tagName === 'IMG') { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = full; }
          pdp.querySelectorAll('[data-mf-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
      // thumbnail slider arrows (present only when > 4 images)
      var strip = pdp.querySelector('[data-mf-thumbs]');
      var tPrev = pdp.querySelector('[data-mf-thumb-prev]');
      var tNext = pdp.querySelector('[data-mf-thumb-next]');
      if (strip && (tPrev || tNext)) {
        var updArrows = function () {
          var max = strip.scrollWidth - strip.clientWidth - 2;
          if (tPrev) tPrev.disabled = strip.scrollLeft <= 2;
          if (tNext) tNext.disabled = strip.scrollLeft >= max;
        };
        if (tPrev) tPrev.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth, behavior: 'smooth' }); });
        if (tNext) tNext.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth, behavior: 'smooth' }); });
        strip.addEventListener('scroll', updArrows);
        updArrows();
      }
      // option pills (size etc.)
      pdp.querySelectorAll('[data-mf-option]').forEach(function (group) {
        group.querySelectorAll('[data-mf-value]').forEach(function (pill) {
          pill.addEventListener('click', function () {
            group.querySelectorAll('[data-mf-value]').forEach(function (p) { p.classList.remove('is-active'); });
            pill.classList.add('is-active');
            syncVariant(pdp);
          });
        });
      });
      // bundle radios
      pdp.querySelectorAll('[data-mf-bundle]').forEach(function (b) {
        b.addEventListener('click', function () {
          pdp.querySelectorAll('[data-mf-bundle]').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          var hid = pdp.querySelector('input[name="id"]');
          if (hid && b.getAttribute('data-variant')) hid.value = b.getAttribute('data-variant');
          var qty = pdp.querySelector('input[name="quantity"]');
          if (qty && b.getAttribute('data-qty')) qty.value = b.getAttribute('data-qty');
          updateCartButton(pdp, b);
        });
      });
    });
  }
  function syncVariant(pdp) {
    // map selected option pills -> matching variant id via data-variant-map JSON
    var mapEl = pdp.querySelector('[data-variant-map]');
    if (!mapEl) return;
    var map; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    var chosen = [];
    pdp.querySelectorAll('[data-mf-option] .is-active').forEach(function (p) { chosen.push(p.getAttribute('data-mf-value')); });
    var key = chosen.join(' / ');
    if (map[key]) {
      var hid = pdp.querySelector('input[name="id"]');
      if (hid) hid.value = map[key].id;
    }
  }
  function updateCartButton(pdp, b) {
    var btn = pdp.querySelector('[data-mf-atc-label]');
    if (btn && b.getAttribute('data-price')) btn.textContent = btn.getAttribute('data-prefix') + ' ' + b.getAttribute('data-price');
  }

  /* ---------- UGC video tiles ---------- */
  function initUgc(root) {
    (root || document).querySelectorAll('[data-mf-ugc-play]').forEach(function (btn) {
      if (btn.__mf) return; btn.__mf = 1;
      var tile = btn.closest('[data-mf-ugc]');
      var v = tile && tile.querySelector('.mf-reviews__vid');
      if (!v) return;
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      btn.addEventListener('click', play);
      v.addEventListener('click', function () { if (v.paused) play(); else v.pause(); });
      v.addEventListener('play', function () { btn.setAttribute('hidden', ''); });
      v.addEventListener('pause', function () { btn.removeAttribute('hidden'); });
      v.addEventListener('ended', function () { btn.removeAttribute('hidden'); });
    });
    (root || document).querySelectorAll('[data-mf-ugc-embed]').forEach(function (btn) {
      if (btn.__mf) return; btn.__mf = 1;
      btn.addEventListener('click', function () {
        var tile = btn.closest('[data-mf-ugc]'); if (!tile) return;
        var type = btn.getAttribute('data-embed-type'), id = btn.getAttribute('data-embed-id');
        var src = type === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
          : 'https://www.youtube.com/embed/' + id + '?autoplay=1';
        var f = document.createElement('iframe');
        f.src = src; f.allow = 'autoplay; encrypted-media; fullscreen'; f.setAttribute('allowfullscreen', '');
        tile.appendChild(f);
        btn.setAttribute('hidden', '');
        var img = tile.querySelector('.mf-img'); if (img) img.style.display = 'none';
      });
    });
  }

  /* ---------- UGC video strip (mf-ugc section) ----------
     Tiles autoplay MUTED while ≥35% in view and pause off-screen. Clicking a
     tile (or its speaker badge) opens a reels-style modal that plays the video
     FROM THE START with sound; ✕ / backdrop / Esc close it and the tile
     resumes its muted loop. prefers-reduced-motion skips the inline autoplay. */
  // Clicking a tile enlarges it IN PLACE (scale 1.25, transform-only), restarts the
  // video from 0:00 with sound; clicking again / Esc / scrolling it out of view
  // shrinks and re-mutes it. Only one tile is "live" at a time. Edge tiles grow
  // inward (transform-origin picked at click time) so the scroll row never clips them.
  var ugcLive = null;
  function ugcLiveOff() {
    if (!ugcLive) return;
    var v = ugcLive.querySelector('video');
    if (v) v.muted = true;
    ugcLive.classList.remove('is-live');
    ugcLive.style.transformOrigin = '';
    ugcLive = null;
  }
  function ugcLiveOn(v) {
    var tile = v.closest('.mf-ugcs__tile'); if (!tile) return;
    if (ugcLive === tile) { ugcLiveOff(); return; }
    ugcLiveOff();
    ugcLive = tile;
    var row = tile.closest('[data-mf-ugcs-row]');
    if (row) {
      var rr = row.getBoundingClientRect(), tr = tile.getBoundingClientRect();
      var grow = tr.width * 0.13 + 6;
      tile.style.transformOrigin = (tr.left - rr.left < grow) ? 'left center'
        : (rr.right - tr.right < grow) ? 'right center' : 'center center';
    }
    tile.classList.add('is-live');
    try { v.currentTime = 0; } catch (err) {}
    v.muted = false;
    var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
  }
  function initUgcStrip(root) {
    var vids = (root || document).querySelectorAll('[data-mf-ugcs] video');
    if (!vids.length) return;
    if (!window.__mfUgcEsc) {
      window.__mfUgcEsc = 1;
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') ugcLiveOff(); });
    }
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = !reduced && 'IntersectionObserver' in window
      ? new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting && en.intersectionRatio >= 0.35) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else if (!v.paused) {
              v.pause();
              if (ugcLive && ugcLive.contains(v)) ugcLiveOff(); // don't resume with sound later
            }
          });
        }, { threshold: [0, 0.35] })
      : null;
    vids.forEach(function (v) {
      if (v.__mf) return; v.__mf = 1;
      v.muted = true;
      if (io) io.observe(v);
      v.addEventListener('click', function () { ugcLiveOn(v); });
    });
    // Slider controls: arrow paging + mouse drag-to-swipe (touch scrolls natively).
    // A drag past 8px swallows the click so it doesn't open the modal.
    (root || document).querySelectorAll('[data-mf-ugcs]').forEach(function (sec) {
      var row = sec.querySelector('[data-mf-ugcs-row]');
      if (!row || row.__mf) return; row.__mf = 1;
      var prev = sec.querySelector('[data-mf-ugcs-prev]');
      var next = sec.querySelector('[data-mf-ugcs-next]');
      function paint() {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft >= max;
      }
      // No CSS scroll-snap or scroll-behavior:smooth (both silently break JS scrolls
      // in Chrome on a row full of playing videos) — page with a rAF tween instead,
      // landing on exact tile edges.
      function glide(target) {
        target = Math.max(0, Math.min(target, row.scrollWidth - row.clientWidth));
        var from = row.scrollLeft, d = target - from, t0 = null;
        if (!d) return;
        cancelAnimationFrame(row.__mfGlide);
        var dur = reduced ? 0 : 420;
        function tick(ts) {
          if (t0 === null) t0 = ts;
          var p = dur ? Math.min(1, (ts - t0) / dur) : 1;
          row.scrollLeft = from + d * (1 - Math.pow(1 - p, 3)); // easeOutCubic
          if (p < 1) row.__mfGlide = requestAnimationFrame(tick);
        }
        row.__mfGlide = requestAnimationFrame(tick);
      }
      function page(dir) {
        var t = row.querySelectorAll('.mf-ugcs__tile');
        var step = t.length > 1 ? t[1].offsetLeft - t[0].offsetLeft : row.clientWidth;
        var per = Math.max(1, Math.round(row.clientWidth / step));
        glide(Math.round((row.scrollLeft + dir * per * step) / step) * step);
      }
      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      row.addEventListener('scroll', paint, { passive: true });
      window.addEventListener('resize', paint, { passive: true });
      paint();
      // IMPORTANT: do NOT setPointerCapture on pointerdown — capturing retargets the
      // eventual click to the ROW, so real mouse clicks (which always jitter a few px)
      // never reach the video and the popup "can't be clicked". Capture only once a
      // drag has genuinely started (>12px), and only then suppress the click.
      var down = null, moved = 0;
      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        cancelAnimationFrame(row.__mfGlide); // grabbing the row stops a paging tween
        down = { x: e.clientX, left: row.scrollLeft, id: e.pointerId }; moved = 0;
      });
      row.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - down.x;
        if (Math.abs(dx) > 12 && !row.classList.contains('is-drag')) {
          row.classList.add('is-drag');
          try { row.setPointerCapture(down.id); } catch (err) {}
        }
        if (row.classList.contains('is-drag')) {
          row.scrollLeft = down.left - dx;
          if (Math.abs(dx) > moved) moved = Math.abs(dx);
        }
      });
      function release() { down = null; row.classList.remove('is-drag'); }
      row.addEventListener('pointerup', release);
      row.addEventListener('pointercancel', release);
      row.addEventListener('click', function (e) {
        if (moved > 15) { e.stopPropagation(); e.preventDefault(); }
        moved = 0;
      }, true);
    });
  }

  /* ---------- product anatomy (mf-anatomy section) ----------
     Hovering a feature card lights its numbered hotspot on the product shot and
     vice-versa; tapping a dot flashes its card (mobile). */
  function initAnatomy(root) {
    (root || document).querySelectorAll('[data-mf-anatomy]').forEach(function (sec) {
      if (sec.__mf) return; sec.__mf = 1;
      // centre 360° spin video: play only while in view; skip autoplay for reduced motion
      var vid = sec.querySelector('.mf-anat__stage video');
      if (vid) {
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reduced && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            es.forEach(function (en) {
              if (en.isIntersecting) { var p = en.target.play(); if (p && p.catch) p.catch(function () {}); }
              else en.target.pause();
            });
          }, { threshold: 0.25 }).observe(vid);
        }
      }
      var cards = sec.querySelectorAll('[data-mf-anat-card]');
      var dots = sec.querySelectorAll('[data-mf-anat-dot]');
      // connector lines label → hotspot dot (poster-style callouts)
      var diagram = sec.querySelector('[data-mf-anat-diagram]');
      var svg = diagram && diagram.querySelector('.mf-anat__lines');
      function drawLines() {
        if (!svg || !diagram.offsetParent || getComputedStyle(svg).display === 'none') { if (svg) svg.innerHTML = ''; return; }
        var dr = diagram.getBoundingClientRect();
        svg.setAttribute('viewBox', '0 0 ' + Math.round(dr.width) + ' ' + Math.round(dr.height));
        var html = '';
        cards.forEach(function (lab) {
          var n = lab.getAttribute('data-mf-anat-card');
          var dot = sec.querySelector('[data-mf-anat-dot="' + n + '"]');
          if (!dot) return;
          var lr = lab.getBoundingClientRect(), dd = dot.getBoundingClientRect();
          var isLeft = lab.className.indexOf('--l') > -1;
          var x1 = (isLeft ? lr.right + 10 : lr.left - 10) - dr.left;
          var y1 = lr.top + lr.height / 2 - dr.top;
          var x2 = dd.left + dd.width / 2 - dr.left + (isLeft ? -1 : 1) * (dd.width / 2 + 3);
          var y2 = dd.top + dd.height / 2 - dr.top;
          html += '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"/>' +
                  '<circle cx="' + x1 + '" cy="' + y1 + '" r="2.5" fill="currentColor"/>';
        });
        svg.innerHTML = html;
      }
      if (svg) {
        var redrawSoon = function () { [0, 400, 900, 1600].forEach(function (t) { setTimeout(drawLines, t); }); };
        redrawSoon(); // after reveal animations settle
        // the centre image is lazy-loaded: until it arrives the diagram has no height,
        // so re-measure once it loads and whenever the section first scrolls into view
        var stageImg = diagram.querySelector('.mf-anat__stage img');
        if (stageImg && !stageImg.complete) stageImg.addEventListener('load', redrawSoon, { once: true });
        if ('IntersectionObserver' in window) {
          var seen = new IntersectionObserver(function (es) {
            if (es[0].isIntersecting) { redrawSoon(); seen.disconnect(); }
          }, { threshold: 0.2 });
          seen.observe(diagram);
        }
        window.addEventListener('resize', drawLines, { passive: true });
      }
      function set(n, on) {
        cards.forEach(function (c) { c.classList.toggle('is-hot', on && c.getAttribute('data-mf-anat-card') === n); });
        dots.forEach(function (d) { d.classList.toggle('is-hot', on && d.getAttribute('data-mf-anat-dot') === n); });
      }
      cards.forEach(function (c) {
        var n = c.getAttribute('data-mf-anat-card');
        c.addEventListener('mouseenter', function () { set(n, true); });
        c.addEventListener('mouseleave', function () { set(n, false); });
      });
      dots.forEach(function (d) {
        var n = d.getAttribute('data-mf-anat-dot');
        d.addEventListener('mouseenter', function () { set(n, true); });
        d.addEventListener('mouseleave', function () { set(n, false); });
        d.addEventListener('click', function () {
          set(n, true);
          clearTimeout(sec.__mfAnatT);
          sec.__mfAnatT = setTimeout(function () { set(n, false); }, 1800);
        });
      });
    });
  }

  /* ---------- sticky ATC ---------- */
  function stickyScan() {
    var bar = document.querySelector('[data-mf-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-mf-atc-anchor]');
    var show;
    if (anchor) {
      var r = anchor.getBoundingClientRect();
      show = r.bottom < 0 || r.top > (window.innerHeight || 800);
    } else {
      show = (window.scrollY || 0) > 600;
    }
    bar.classList.toggle('is-visible', show);
  }

  /* ---------- cart drawer (Shopify AJAX cart) ---------- */
  function mfMoney(cents) { return '₹' + Math.round((cents || 0) / 100).toLocaleString('en-IN'); }
  var reserveTimer = null, reserveSecs = 300;
  function renderCart(cart) {
    var root = document.querySelector('[data-mf-cart]'); if (!root) return;
    var lines = root.querySelector('[data-mf-cart-lines]');
    var empty = root.querySelector('[data-mf-cart-empty]');
    var foot = root.querySelector('[data-mf-cart-foot]');
    var count = cart.item_count || 0;
    document.querySelectorAll('[data-mf-cart-count]').forEach(function (e) { e.textContent = '• ' + count + ' item' + (count === 1 ? '' : 's'); });
    document.querySelectorAll('.mf-header__cart-count').forEach(function (e) {
      var prev = e.textContent;
      e.textContent = count;
      if (prev !== String(count)) { e.classList.remove('is-bump'); void e.offsetWidth; e.classList.add('is-bump'); }
    });
    var ship = root.querySelector('[data-mf-cart-ship]');
    var reserve = root.querySelector('.mf-cart__reserve');
    if (count === 0) {
      if (empty) empty.style.display = ''; if (lines) lines.innerHTML = ''; if (foot) foot.hidden = true;
      if (ship) ship.hidden = true; if (reserve) reserve.hidden = true;
      return;
    }
    if (empty) empty.style.display = 'none'; if (foot) foot.hidden = false;
    if (reserve) reserve.hidden = false;
    // Quantity-tier bundle offer (mirrors the Fastrr BUNDLESAVE tiers; applied for real at checkout).
    // Display splits the free units into their own FREE line and anchors paid units at the
    // marketing MRP so the visible math matches the PDP: paid @ MRP − bundle OFF = estimated total.
    var tier = bestOfferTier(root, count);
    var estTotal = cart.total_price - (tier ? tier.off : 0);
    var freeTotal = (tier && tier.free) ? Math.min(tier.free, count - 1) : 0;
    var paidCount = count - freeTotal;
    var showMrp = tier && freeTotal > 0 && tier.offShown > 0;
    var paidShownTotal = showMrp ? estTotal + tier.offShown : 0;
    // allocate free units from the last cart line backwards
    var freeAlloc = {}, leftFree = freeTotal;
    for (var fi = cart.items.length - 1; fi >= 0 && leftFree > 0; fi--) {
      var take = Math.min(cart.items[fi].quantity, leftFree);
      freeAlloc[fi] = take; leftFree -= take;
    }
    var html = '', paidShownLeft = paidShownTotal, paidLeft = paidCount;
    cart.items.forEach(function (it, idx) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy">' : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="mf-cart__line-variant">' + it.variant_title + '</div>' : '';
      var freeQ = freeAlloc[idx] || 0;
      var paidQ = it.quantity - freeQ;
      if (paidQ > 0) {
        var priceNow;
        if (showMrp) {
          var share = (paidQ === paidLeft) ? paidShownLeft : Math.round(paidShownTotal * paidQ / paidCount);
          paidShownLeft -= share; paidLeft -= paidQ;
          priceNow = mfMoney(share);
        } else {
          priceNow = mfMoney(it.final_line_price);
        }
        html += '<div class="mf-cart__line" data-key="' + it.key + '" data-qty="' + it.quantity + '">'
          + '<div class="mf-cart__thumb">' + img + '</div>'
          + '<div class="mf-cart__line-main">'
          + '<div class="mf-cart__line-top"><div class="mf-cart__line-title">' + it.product_title + '</div>'
          + '<button class="mf-cart__remove" data-mf-remove aria-label="Remove"><svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M5 7h14M10 7V5h4v2M6 7l1 12a1.5 1.5 0 0 0 1.5 1.4h7A1.5 1.5 0 0 0 18 19L19 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>'
          + variant
          + '<div class="mf-cart__line-bottom">'
          + '<div class="mf-cart__step"><button data-mf-dec aria-label="Decrease">−</button><span>' + paidQ + '</span><button data-mf-inc aria-label="Increase">+</button></div>'
          + '<div class="mf-cart__line-price"><div class="mf-cart__line-now">' + priceNow + '</div></div>'
          + '</div></div></div>';
      }
      if (freeQ > 0) {
        var freeWas = tier.mrpUnit ? '<div class="mf-cart__line-was">' + mfMoney(tier.mrpUnit * freeQ) + '</div>' : '';
        html += '<div class="mf-cart__line mf-cart__line--free">'
          + '<div class="mf-cart__thumb">' + img + '<span class="mf-cart__free-flag">FREE</span></div>'
          + '<div class="mf-cart__line-main">'
          + '<div class="mf-cart__line-top"><div class="mf-cart__line-title">' + it.product_title + ' <span class="mf-cart__free-badge">FREE</span></div></div>'
          + variant
          + '<div class="mf-cart__line-note">🎁 ' + freeQ + ' × yours free with this pack</div>'
          + '<div class="mf-cart__line-bottom"><span></span>'
          + '<div class="mf-cart__line-price">' + freeWas + '<div class="mf-cart__line-now mf-cart__line-now--free">FREE</div></div>'
          + '</div></div></div>';
      }
    });
    lines.innerHTML = html;
    var bundleRow = root.querySelector('[data-mf-cart-bundle]');
    if (bundleRow) {
      bundleRow.hidden = !tier;
      if (tier) {
        var bl = bundleRow.querySelector('[data-mf-cart-bundle-label]');
        var bo = bundleRow.querySelector('[data-mf-cart-bundle-off]');
        if (bl) bl.textContent = tier.label || 'Bundle offer';
        if (bo) bo.textContent = '−' + mfMoney(showMrp ? tier.offShown : tier.off);
      }
    }
    var savEl = root.querySelector('[data-mf-cart-savings]');
    if (savEl && savEl.parentElement) savEl.parentElement.hidden = true;
    root.querySelector('[data-mf-cart-subtotal]').textContent = mfMoney(estTotal);
    // stepper context: the +/- buttons think in PAID units (see initCart).
    // NOTE: must NOT be named data-mf-count — that attribute belongs to the stats
    // counter animation, which would then wipe the drawer's DOM with a number.
    root.setAttribute('data-mf-items', count);
    root.setAttribute('data-mf-free', freeTotal);
    updateShipBar(root);
    syncFastrrBtn(root);
    // delivery promise line ("Ships from Delhi in 24 hrs") — visible while the cart has items
    var stockEl = root.querySelector('[data-mf-cart-stock]');
    if (stockEl) stockEl.hidden = count === 0;
  }
  // Tier granted for a given PAID quantity (tier.qty - tier.free = paid units needed)
  function paidTierFor(root, paid) {
    var el = root.querySelector('[data-mf-cart-offers]');
    if (!el) return null;
    try {
      var tiers = JSON.parse(el.textContent);
      for (var i = 0; i < tiers.length; i++) {
        var need = tiers[i].qty - (tiers[i].free || 0);
        if (tiers[i].free && paid >= need) return tiers[i];
      }
    } catch (e) {}
    return null;
  }
  // Highest tier whose min quantity the cart meets ([data-mf-cart-offers] JSON, sorted desc by qty)
  function bestOfferTier(root, count) {
    var el = root.querySelector('[data-mf-cart-offers]');
    if (!el) return null;
    try {
      var tiers = JSON.parse(el.textContent);
      for (var i = 0; i < tiers.length; i++) {
        if (count >= tiers[i].qty) return tiers[i];
      }
    } catch (e) {}
    return null;
  }
  // Delivery perk strip (static message set in the snippet; shown only when cart has items)
  function updateShipBar(root) {
    var bar = root.querySelector('[data-mf-cart-ship]');
    if (bar) bar.hidden = false;
  }
  // If Fastrr renders its BUY NOW button into the mini-cart mount, hide the fallback button.
  function syncFastrrBtn(root) {
    var sr = root.querySelector('.mf-cart__sr');
    var fb = root.querySelector('[data-mf-cart-checkout]');
    if (!fb) return;
    var has = sr && sr.querySelector('button, a, .sr-headless-checkout');
    fb.style.display = has ? 'none' : '';
  }
  function fetchCart(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); if (cb) cb(c); })
      .catch(function () {});
  }
  function startReserve() {
    stopReserve();
    var el = document.querySelector('[data-mf-reserve]');
    reserveTimer = setInterval(function () {
      if (reserveSecs > 0) reserveSecs--;
      if (el) el.textContent = Math.floor(reserveSecs / 60) + ':' + String(reserveSecs % 60).padStart(2, '0');
    }, 1000);
  }
  function stopReserve() { if (reserveTimer) clearInterval(reserveTimer); reserveTimer = null; }
  function cartOpen() {
    var r = document.querySelector('[data-mf-cart]'); if (!r) return;
    r.hidden = false; document.documentElement.style.overflow = 'hidden';
    reserveSecs = 300; startReserve(); fetchCart();
  }
  function cartClose() {
    var r = document.querySelector('[data-mf-cart]'); if (!r) return;
    r.hidden = true; document.documentElement.style.overflow = ''; stopReserve();
  }
  function changeLine(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function initCart() {
    var root = document.querySelector('[data-mf-cart]'); if (!root || root.__mf) return; root.__mf = 1;
    document.querySelectorAll('[data-mf-cart-close]').forEach(function (b) { b.addEventListener('click', cartClose); });
    document.querySelectorAll('[data-mf-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); cartOpen(); }); });
    // Fastrr injects its branded button whenever its (lazy, retried) loader comes up —
    // possibly after the drawer last rendered — so swap the fallback out on injection too.
    var srMount = root.querySelector('.mf-cart__sr');
    if (srMount && window.MutationObserver) {
      new MutationObserver(function () { syncFastrrBtn(root); }).observe(srMount, { childList: true, subtree: true });
    }
    var co = root.querySelector('[data-mf-cart-checkout]');
    if (co) co.addEventListener('click', function (e) {
      e.preventDefault();
      // Route checkout through Fastrr 1-click (Shiprocket) when it's loaded; fall back to Shopify checkout.
      if (window.shiprocketCheckoutEvents && typeof window.shiprocketCheckoutEvents.buyCart === 'function') {
        try { window.shiprocketCheckoutEvents.buyCart(e); return; } catch (err) {}
      }
      window.location.href = '/checkout';
    });
    root.addEventListener('click', function (e) {
      var line = e.target.closest('.mf-cart__line'); if (!line) return;
      var key = line.getAttribute('data-key'); if (!key) return; // synthetic FREE lines have no key
      var q = parseInt(line.getAttribute('data-qty') || '1', 10) || 1;
      // Steppers think in PAID units: recompute the real cart quantity (paid + earned free)
      // from the offer tiers so the visible counter always moves and FREE lines stay in sync.
      var count = parseInt(root.getAttribute('data-mf-items') || '0', 10) || 0;
      var free = parseInt(root.getAttribute('data-mf-free') || '0', 10) || 0;
      var paid = Math.max(1, count - free);
      var realFor = function (p) { var t = paidTierFor(root, p); return p + (t && t.free ? t.free : 0); };
      if (e.target.closest('[data-mf-inc]')) {
        var upTarget = realFor(paid);                             // first claim any unclaimed free units
        var desiredUp = count < upTarget ? upTarget : realFor(paid + 1);
        changeLine(key, Math.max(1, q + (desiredUp - count)));
        return;
      }
      if (e.target.closest('[data-mf-dec]')) {
        if (paid <= 1) { changeLine(key, 0); return; }            // below 1 paid unit -> remove
        var desiredDown = realFor(paid - 1);
        changeLine(key, Math.max(0, q + (desiredDown - count)));
        return;
      }
      if (e.target.closest('[data-mf-remove]')) changeLine(key, 0);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cartClose(); });
    fetchCart();
  }
  function initAtc() {
    if (window.__mfAtc) return; window.__mfAtc = 1;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var fd = new FormData(form);
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.dataset.mfLabel = btn.textContent; btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (item) {
          // Meta Pixel AddToCart — FALLBACK ONLY: when Fastrr's tracker is loaded it
          // auto-fires AddToCart itself (verified live), so firing ours too would
          // double-count. Ours covers only adds that happen before Fastrr boots.
          // Checkout + purchase events fire from Fastrr's tracking, never from the theme.
          try {
            if (typeof window.fbq === 'function' && !window.isFastrrUp && item && item.product_id) {
              window.fbq('track', 'AddToCart', {
                content_ids: [String(item.product_id)],
                content_type: 'product',
                content_name: item.product_title || '',
                value: ((item.final_price || item.price || 0) / 100) * (item.quantity || 1),
                currency: 'INR'
              });
            }
          } catch (err) {}
          cartOpen();
        })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) { btn.disabled = false; } });
    });
  }

  /* ---------- scroll-to-top ---------- */
  function totopScan() {
    var b = document.querySelector('[data-mf-totop]'); if (!b) return;
    b.hidden = (window.scrollY || 0) <= 500;
  }
  function initTotop() {
    var b = document.querySelector('[data-mf-totop]'); if (!b || b.__mf) return; b.__mf = 1;
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  }

  /* ---------- social-proof toast ---------- */
  var popData = null, popIdx = 0, popTimer = null, popDismissed = false;
  function showPop() {
    if (popDismissed) return;
    var el = document.querySelector('[data-mf-pop]'); if (!el || !popData || !popData.length) return;
    var p = popData[popIdx % popData.length]; popIdx++;
    var av = el.querySelector('[data-mf-pop-avatar]'); av.textContent = p.initials; av.style.background = p.color;
    el.querySelector('[data-mf-pop-name]').textContent = p.name;
    el.querySelector('[data-mf-pop-city]').textContent = 'in ' + p.city;
    el.querySelector('[data-mf-pop-text]').textContent = p.text;
    el.hidden = false; el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
    clearTimeout(el.__hide); el.__hide = setTimeout(function () { el.hidden = true; }, 5600);
  }
  function initPop() {
    var el = document.querySelector('[data-mf-pop]'); if (!el || el.__mf) return; el.__mf = 1;
    var d = document.querySelector('[data-mf-pops]'); if (!d) return;
    try { popData = JSON.parse(d.textContent); } catch (e) { return; }
    if (!popData || !popData.length) return;
    var close = el.querySelector('[data-mf-pop-close]');
    if (close) close.addEventListener('click', function () {
      popDismissed = true; el.hidden = true;
      if (popTimer) clearInterval(popTimer); clearTimeout(el.__hide);
    });
    setTimeout(showPop, 2500);
    popTimer = setInterval(showPop, 9000);
  }

  /* ---------- Fastrr overlay guard ---------- */
  // Fastrr's checkout overlay (#fastrr-main-container) can survive a dismissed checkout:
  // an invisible max-z-index iframe keeps eating every click, body scroll stays locked,
  // and their loader refuses to re-open while it exists (CHECKOUT_ALREADY_INIT) — so the
  // whole page appears frozen. Mirror their own close cleanup (they remove the container
  // and set body overflow to auto) and wire it to Esc, a floating ✕, and the buy buttons.
  function fastrrCleanup() {
    var hc = document.getElementById('headless-container');
    var c = document.getElementById('fastrr-main-container');
    if (hc) hc.remove();
    if (c) c.remove();
    document.body.style.overflow = 'auto';
    document.body.style.height = '';
  }
  function initFastrrGuard() {
    if (window.__mfFrGuard) return; window.__mfFrGuard = 1;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Close checkout');
    btn.className = 'mf-fastrr-esc';
    btn.innerHTML = '✕';
    btn.hidden = true;
    btn.addEventListener('click', fastrrCleanup);
    document.body.appendChild(btn);
    setInterval(function () {
      var c = document.getElementById('fastrr-main-container');
      var show = !!(c && c.offsetWidth > 0);
      if (btn.hidden !== !show) btn.hidden = !show;
      if (show && btn !== document.body.lastElementChild) document.body.appendChild(btn); // keep painted above the overlay
    }, 800);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.getElementById('fastrr-main-container')) fastrrCleanup();
    });
    // Self-heal: a click on any buy button means the user does NOT see an open checkout —
    // clear a stale overlay first so Fastrr can re-init instead of silently failing.
    var wrapTimer = setInterval(function () {
      var sr = window.shiprocketCheckoutEvents;
      if (!sr || sr.__mfWrapped) return;
      clearInterval(wrapTimer); sr.__mfWrapped = 1;
      ['buyCart', 'buyProduct', 'buyDirect', 'buyProductFlits'].forEach(function (k) {
        var orig = sr[k];
        if (typeof orig !== 'function') return;
        sr[k] = function () {
          if (document.getElementById('fastrr-main-container')) fastrrCleanup();
          return orig.apply(this, arguments);
        };
      });
    }, 500);
  }

  /* ---------- pause infinite marquees while off-screen ---------- */
  // The announcement bar + PDP pay-strip animate forever; when scrolled out of
  // view they still keep the compositor busy — a real battery/jank cost on mobile.
  function initMarqueePause() {
    if (!('IntersectionObserver' in window)) return;
    var tracks = document.querySelectorAll('.mf-annc__track, .mf-pdp__pay-track');
    if (!tracks.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        en.target.style.animationPlayState = en.isIntersecting ? 'running' : 'paused';
      });
    }, { rootMargin: '80px 0px' });
    tracks.forEach(function (t) { if (!t.__mfMqIo) { t.__mfMqIo = 1; io.observe(t); } });
  }

  function boot() {
    armReveals();
    initAccordions();
    initPdp();
    initCart();
    initAtc();
    initTotop();
    initPop();
    initUgc();
    initUgcStrip();
    initAnatomy();
    initFastrrGuard();
    initMarqueePause();
    [120, 400, 900].forEach(function (t) { setTimeout(revealScan, t); });
    stickyScan();
    totopScan();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Theme-editor support: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    armReveals(); revealScan();
    initAccordions(e.target); initPdp(e.target);
    initCart(); initTotop(); initPop(); initUgc(e.target); initUgcStrip(e.target); initAnatomy(e.target);
  });
})();
